module.exports = __webpack_public_path__ + "media/images/elevate_honors-1c7f90b92363b134f0380df1685a3ef0.png";